import React from "react";

import CustomSelect from "components/common/select/SelectField";
import SearchField from "components/common/customSearchField/CustomSearchField";
import Filterbars from "assets/icons/Filterbars";

import "./payment.scss";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
const PaymentActionBar = () => {
  const { t } = useTranslation();
  const due = [
    { value: 1, name: t("due-date-desc") },
    { value: 2, name: t("due-date-desc") },
  ];
  const branches = [
    { value: 1, name: t("all-branches")},
    { value: 2, name: "Gecco branches" },
    { value: 3, name: "Future-Care branches" },
  ];

  return (
    <div className="maindiv d-flex justify-content-between align-items-end mt-3">
      <Row className="eguser d-flex w-100">
        <Col
          lg={1}
          xs={12}
          className="d-flex align-items-center justify-content-xxs-center"
        >
          <Filterbars style={{ marginTop: "20px" }} />
        </Col>
        <Col lg={3} xs={12} className="mt-xxs-4">
          <CustomSelect
            list={due}
            size="md"
            width="100%"
            height="100%"
            className="m-xxs-0 py-xxs-2"
          />
        </Col>
        <Col lg={3} xs={12} className="mt-xxs-4">
          <CustomSelect
            list={branches}
            size="md"
            width="100%"
            height="100%"
            className="m-xxs-0 py-xxs-2"
          />
        </Col>
        <Col lg={3} xs={12} className="mt-xxs-4">
          <div className="w-100">
            <SearchField margin="0" padding="0.4rem" />
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default PaymentActionBar;
